import { Icon, InputGroup, Intent, TextArea } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Clearfix from 'components/elements/clearfix';
// import { Link } from 'react-router-dom';
// import slug from 'constants/slug';
import IconRequired from 'components/elements/required-icon';
import EmissionTypeSelect from 'components/elements/select-emission-type';
import FacilitySelect from 'components/elements/select-facility';
import { COLOR } from 'config';
// import { STYLE } from 'config';
// import dynamicRoleHOC from 'hoc/dynamicRole';
import PropTypes from 'prop-types';
import { createForm } from 'rc-form';
import React from 'react';
import { Col, Row } from 'reactstrap';
// import * as _ from 'lodash';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

// @dynamicRoleHOC()
class FacilityemissionForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
    // facility: PropTypes.shape({
    //   _id: PropTypes.string,
    //   FacilityNameFull: PropTypes.string
    // })
  };

  
  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }
    return defaultValue;
  }

  submit = (isAddNew) => {
    this.props.form.validateFields((error, value) => {
      value.facility = _.get(value.facility, 'value');
      value.emissionType = _.get(value.emissionType, 'value');
      // console.log(value);
      if (error) return;
      if (this.props.handelSubmit) this.props.handelSubmit(value, isAddNew);
    });
  };

  resetForm() {
    this.props.form.resetFields([
      'Name',
      'DataValue',
      'Description',
      'emissionType',
    ]);
  }

  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    return (
      <div>
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Quản lý ô nhiễm
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={() => {
                  this.submit();
                }}
                style={{color: COLOR.SUCCESS}}
              />
              <Clearfix width={8} />

              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
              />
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={10} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <FacilitySelect
              isDisabled={this.props.facility ? true : false}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.props.facility
                    ? {
                      value: this.props.facility._id,
                      label: this.props.facility.FacilityNameFull,
                    }
                    : null,
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn Tên cơ sở/dự án',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('facility') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={10} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Loại chất thải <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <EmissionTypeSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'emissionType',
                option: {
                  initialValue: this.setSelInitialValue('emissionType', null),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn loại chất thải',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('emissionType') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={10} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Giá trị <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Giá trị'
              {...getFieldProps('DataValue', {
                initialValue: this.setInitialValue('DataValue', ''),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập Giá trị',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('DataValue') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={10} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Người quản lý</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              large
              placeholder='Người quản lý'
              {...getFieldProps('Manager', {
                initialValue: this.setInitialValue('Manager', ''),
              })}
            />
          </Col>
        </Row>

        <Clearfix height={10} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Bằng cấp người quản lý</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              large
              placeholder='Bằng cấp người quản lý'
              {...getFieldProps('Degree', {
                initialValue: this.setInitialValue('Degree', ''),
              })}
            />
          </Col>
        </Row>

        <Clearfix height={10} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Hình thức quản lý</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              large
              placeholder='Hình thức quản lý'
              {...getFieldProps('ManagementType', {
                initialValue: this.setInitialValue('ManagementType', ''),
              })}
            />
          </Col>
        </Row>

        <Clearfix height={10} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Đường dẫn (URL)</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              large
              placeholder='Đường dẫn (URL)'
              {...getFieldProps('url', {
                initialValue: this.setInitialValue('url', ''),
                rules: [
                  {
                    type: 'url',
                    message: 'Vui lòng nhập đúng định dạng https://example.com',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('url') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={10} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Nguồn trích dẫn</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              large
              placeholder='Nguồn trích dẫn'
              {...getFieldProps('reference', {
                initialValue: this.setInitialValue('reference', ''),
              })}
            />
          </Col>
        </Row>

        <Clearfix height={10} />

        <Row>
          <Col xs={4}>
            <LabelContainer>Ghi chú</LabelContainer>
          </Col>
          <Col xs={4}>
            <TextArea
              style={{ width: '100%' }}
              large
              placeholder=''
              {...getFieldProps('Description', {
                initialValue: this.setInitialValue('Description', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={10} />
      </div>
    );
  }
}

export default createForm()(FacilityemissionForm);



// WEBPACK FOOTER //
// ./src/containers/FacilityemissionContainer/FacilityemissionForm/index.js